import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},
	paginationContainer: {
		display: 'flex',
		justifyContent: 'center',
	},
	actionCell: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	cellStyle: {
		whiteSpace: 'nowrap',
		minWidth: '80px',
	},
}));
